import styled from "styled-components";

/**
 * Charte graphique "Pilotage RH".
 * Toutes les variables sont scopées au wrapper de la page (préfixe --prh-)
 * pour ne pas entrer en collision avec les tokens globaux (globalStyles.js).
 */
export const PageRoot = styled.div`
    /* ---- Couleurs de marque ---- */
    --prh-violet: #5b5fc7;
    --prh-violet-dark: #4a4eae;
    --prh-violet-mid: #8e92da;
    --prh-violet-soft: #c5cbfa;
    --prh-violet-bg: #eeeffa;
    --prh-violet-line: #dcdef6;

    --prh-blue: #68c9ff;
    --prh-blue-soft: #bde7ff;
    --prh-blue-bg: #eaf6ff;

    --prh-grey: #b7bbc3;
    --prh-amber: #d97706;

    /* ---- Texte ---- */
    --prh-ink: #242424;
    --prh-muted: #616161;
    --prh-muted-2: #8a8a8a;

    /* ---- Surfaces & bordures ---- */
    --prh-bg: #f5f5f5;
    --prh-card: #ffffff;
    --prh-line: #ededed;
    --prh-line-2: #e4e4e7;

    /* ---- Formes ---- */
    --prh-radius: 8px;
    --prh-radius-sm: 6px;
    --prh-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    --prh-shadow-float: 0 8px 24px rgba(0, 0, 0, 0.12);

    /* ---- Typographie ---- */
    --prh-font-xs: 11px;
    --prh-font-sm: 12.5px;
    --prh-font-base: 13.5px;
    --prh-font-md: 14px;
    --prh-font-lg: 15px;
    --prh-font-xl: 20px;
    --prh-font-kpi: 28px;

    /* ---- Espacements ---- */
    --prh-space-xs: 4px;
    --prh-space-sm: 8px;
    --prh-space-md: 14px;
    --prh-space-lg: 24px;
    --prh-space-xl: 32px;

    /* ---- Layout ---- */
    --prh-max-width: 1160px;
    --prh-gutter: 24px;
    --prh-filterbar-height: 58px;

    font-family: "Segoe UI", "Segoe UI Web", system-ui, -apple-system,
        sans-serif;
    background: var(--prh-bg);
    color: var(--prh-ink);
    -webkit-font-smoothing: antialiased;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

/**
 * Couleurs utilisables dans les attributs SVG (fill / stroke).
 * On référence les variables CSS pour rester alignés avec la charte.
 */
export const CHART_COLORS = {
    violet: "var(--prh-violet)",
    violetDark: "var(--prh-violet-dark)",
    violetMid: "var(--prh-violet-mid)",
    violetSoft: "var(--prh-violet-soft)",
    blue: "var(--prh-blue)",
    blueSoft: "var(--prh-blue-soft)",
    grey: "var(--prh-grey)",
    amber: "var(--prh-amber)",
    ink: "var(--prh-ink)",
    muted: "var(--prh-muted)",
    muted2: "var(--prh-muted-2)",
    line: "var(--prh-line)",
};
